module.exports = __webpack_public_path__ + "img/avatardefauter.8db7376f.png";